import Tabs from "../commons/Tabs/Tabs";
import { Outlet } from "react-router-dom";
import { Header, Main } from "../commons/Template/Template";
import routes from "../../routes/routes";
import useRootRedirect from "../../hooks/commons/useRootRedirect";
import { useTranslation } from "react-i18next";
import TreasuryIndicators from "./Common/TreasuryIndicators";
import { TreasuryProvider } from "./Common/TreasuryContext";
import { IndicatorsProvider } from "./Common/IndicatorsContext";
import { AlertsProvider } from "./Common/AlertsContext";
import Typo from "../commons/Typo/Typo";

export default function Treasury() {
  const { t } = useTranslation(["common", "treasury"]);
  document.title = t("treasury:heading");

  const tabs = Object.entries(routes.Treasury)
    .filter(([key]) => key !== "root")
    .map(([key, value]) => ({
      to: value,
      title: t(`treasury:${key}.title`),
    }));

  useRootRedirect(routes.Treasury.root, routes.Treasury.graph);

  return (
    <TreasuryProvider>
      <AlertsProvider>
        <IndicatorsProvider>
          <Main themeSwitch>
            <Header>
              <Typo variant="h1">{t("treasury:heading")}</Typo>
              <Typo variant="body2">{t("treasury:subheading")}</Typo>
            </Header>
            <TreasuryIndicators />
            <Tabs tabs={tabs} smallTabs />
            <Outlet />
          </Main>
        </IndicatorsProvider>
      </AlertsProvider>
    </TreasuryProvider>
  );
}
